import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p07 } from "../../../layouts/ch6_p07/ch6_p07";

export class Chapter6Page7 extends AbstractStoryState implements ReturnType<typeof ch6_p07> {

    readonly bg = this.addChild(new SceneSprite());

    // todo: z-index all this behind frame and lines
    readonly horse = list(()=>this.addChild(new SceneSprite()));
    readonly tyler = list(()=>this.addChild(new SceneSprite()));
    readonly holly = list(()=>this.addChild(new SceneSprite()));
    readonly tylerFront = list(()=>this.addChild(new SceneSprite()));
    readonly rain = list(()=>this.addChild(SceneSprite.withPrefix("ch6_p07/")));

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p07/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p07/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p07/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p07/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p07.call(this);

        this.horse.forEach(h=>h.visible = false);
        this.horse[0].visible = true;

        this.tyler.forEach(t=>t.visible = false);
        this.tyler[0].visible = true;

        this.holly.forEach(h=>h.visible = false);
        this.holly[0].visible = true;

        this.tylerFront.forEach(t=>t.visible = false);
        this.tylerFront[0].visible = true;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {

        // holly 0->1->2->3
        // tyler 0->1->0->2

        new TimelineLite()
            .call(()=>{
                this.horse[0].FadeOut();
                this.horse[1].FadeIn();

                this.tyler[0].FadeOut();
                this.tyler[1].FadeIn();

                this.holly[0].FadeOut();
                this.holly[1].FadeIn();

                this.tylerFront[0].FadeOut();
                this.tylerFront[1].FadeIn();
            }, undefined, undefined, 1.5)
            .call(()=>{
                this.horse[1].FadeOut();
                this.horse[2].FadeIn();

                this.tyler[1].FadeOut();
                this.tyler[0].FadeIn();

                this.holly[1].FadeOut();
                this.holly[2].FadeIn();

                this.tylerFront[1].FadeOut();
                this.tylerFront[0].FadeIn();
            }, undefined, undefined, 4)
            .call(()=>{
                this.horse[2].FadeOut();
                this.horse[3].FadeIn();

                this.tyler[0].FadeOut();
                this.tyler[2].FadeIn();

                this.holly[2].FadeOut();
                this.holly[3].FadeIn();

                this.tylerFront[0].FadeOut();
                this.tylerFront[2].FadeIn();
            }, undefined, undefined, 6.5)
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "up"});
            }, undefined, undefined, "+=1.5")
    }
}